import { render, staticRenderFns } from "./tableZixuanXiangmu.vue?vue&type=template&id=f8765586"
import script from "./tableZixuanXiangmu.vue?vue&type=script&lang=js"
export * from "./tableZixuanXiangmu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports